import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
import { closingLines } from '../data/offer';
export function ClosingSection() {
  return <section className="border-y border-gray-200 bg-pearl py-16 sm:py-20" aria-labelledby="closing-title" data-id="element-41" data-mp="12su1nsplz4ev">
      <div className="mx-auto max-w-4xl px-4" data-id="element-42" data-mp="xu0jvo3agr8w">
        <h2 id="closing-title" className="text-balance text-center text-3xl font-bold leading-tight tracking-tight text-navy sm:text-4xl" data-id="element-43" data-mp="xs7esd8bqf30">
          Stop Guessing. <span className="text-aqua" data-id="element-44" data-mp="17sge3zxm4gmm">Start Understanding Pharmaceutical Manufacturing & GMP.</span>
        </h2>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3" data-id="element-45" data-mp="1ljl7ikae0coi">
          {closingLines.map((line, index) => <motion.li key={line} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-center gap-3 rounded-lg border-l-4 border-gold bg-white px-4 py-3 text-sm font-medium text-navy shadow-sm" data-id="element-46" data-mp="1hhhs5kklknxy" data-mpi={index}>
              <ChevronRightIcon className="h-4 w-4 shrink-0 text-aqua" aria-hidden="true" data-id="element-47" data-mp="27djh2tutoabd" />
              {line}
            </motion.li>)}
        </ul>
      </div>
    </section>;
}